module.exports = __webpack_public_path__ + "img/redWaterWard.5ea1ef24.svg";